export const actions = {
  FECHAS_SENALADAS_LOAD_REQUESTED: 'FECHAS_SENALADAS_LOAD_REQUESTED',
  FECHAS_SENALADAS_LOAD_SUCCEEDED: 'FECHAS_SENALADAS_LOAD_SUCCEEDED',
  FECHAS_SENALADAS_LOAD_FILED: 'FECHAS_SENALADAS_LOAD_FILED',

  FECHA_SENALADA_UPDATE_REQUESTED: 'FECHA_SENALADA_UPDATE_REQUESTED',
  FECHA_SENALADA_UPDATE_SUCCEEDED: 'FECHA_SENALADA_UPDATE_SUCCEEDED',
  FECHA_SENALADA_UPDATE_FILED: 'FECHA_SENALADA_UPDATE_FILED',

  FECHA_SENALADA_BYID_LOAD_REQUESTED: 'FECHA_SENALADA_BYID_LOAD_REQUESTED',
  FECHA_SENALADA_BYID_LOAD_SUCCEEDED: 'FECHA_SENALADA_BYID_LOAD_SUCCEEDED',
  FECHA_SENALADA_BYID_LOAD_FILED: 'FECHA_SENALADA_BYID_LOAD_FILED',

  FECHA_SENALADA_BYID_LOAD_INSERT_REQUESTED: 'FECHA_SENALADA_BYID_LOAD_INSERT_REQUESTED',

  FECHA_SENALADA_UPDATE_ALL_REQUESTED: 'FECHA_SENALADA_UPDATE_ALL_REQUESTED',
  FECHA_SENALADA_UPDATE_ALL_SUCCEEDED: 'FECHA_SENALADA_UPDATE_ALL_SUCCEEDED',
  FECHA_SENALADA_UPDATE_ALL_FILED: 'FECHA_SENALADA_UPDATE_ALL_FILED',

  FECHA_SENALADA_INSERT_REQUESTED: 'FECHA_SENALADA_INSERT_REQUESTED',
  FECHA_SENALADA_INSERT_SUCCEEDED: 'FECHA_SENALADA_INSERT_SUCCEEDED',
  FECHA_SENALADA_INSERT_FILED: 'FECHA_SENALADA_INSERT_FILED',

  FECHA_SENALADA_DELETE_REQUESTED: 'FECHA_SENALADA_DELETE_REQUESTED',
  FECHA_SENALADA_DELETE_SUCCEEDED: 'FECHA_SENALADA_DELETE_SUCCEEDED',
  FECHA_SENALADA_DELETE_FILED: 'FECHA_SENALADA_DELETE_FILED',
}

export const getFechasSenaladasAction = dispatch => {
  dispatch({
    type: actions.FECHAS_SENALADAS_LOAD_REQUESTED,
  })
}

export const updateFechaAdicionalAction = (dispatch, formFechaAdicional) => {
  dispatch({
    type: actions.FECHA_SENALADA_UPDATE_REQUESTED,
    payload: formFechaAdicional,
  })
}

export const getFechaSenaladaCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.FECHA_SENALADA_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.FECHA_SENALADA_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertFechaSenaladaFormAction = (dispatch, formFechaSenalada) => {
  dispatch({
    type: actions.FECHA_SENALADA_INSERT_REQUESTED,
    payload: formFechaSenalada,
  })
}

export const onSubmitUpdateFechaSenaladaFormAction = (dispatch, formFechaSenalada) => {
  dispatch({
    type: actions.FECHA_SENALADA_UPDATE_ALL_REQUESTED,
    payload: formFechaSenalada,
  })
}

export const deleteFechaAdicionalAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_SENALADA_DELETE_REQUESTED,
    payload: id,
  })
}
